import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { notification, TabsProps } from 'antd';

import ImportarRecibos from './components/Importar';
import CadastrarRecibos from './components/Cadastrar';
import ConfigurarRecibos from './components/ConfigurarRecibos';
import { EmitError } from '../../utils/EmitError';
import RecibosConfigurarService from '../../services/http/services/Recibos/RecibosConfigurarService';
import axios, { AxiosError } from 'axios';
import useAuth from '../../hooks/useAuth';

interface IDisableTabs {
    cadastrarRecibos: boolean,
    importarRecibos: boolean,
}

export default function useRecibos() {

    const { userCan } = useAuth();

    const refController = useRef(new AbortController());

    const [activeKeyTabs, setActiveKeyTabs] = useState<any>();
    const [disabledTabs, setDisabledTabs] = useState<IDisableTabs>(
        {
            cadastrarRecibos: true,
            importarRecibos: true,
        }
    );

    useEffect(() => {
        return () => {
            refController.current.abort();
        }
    }, []);


    const handleHabilitarAbasAposConfig = useCallback(() => {
        setDisabledTabs({
            cadastrarRecibos: false,
            importarRecibos: false
        })
    }, [])

    const items: TabsProps['items'] = useMemo(() => {
        return [
            {
                key: 'cadastrarRecibos',
                label: 'Cadastrar',
                children: disabledTabs.cadastrarRecibos ? <></> : <CadastrarRecibos />,
                disabled: disabledTabs.cadastrarRecibos
            },
            {
                key: 'importarRecibos',
                label: 'Importar',
                children: disabledTabs.importarRecibos ? <></> : <ImportarRecibos />,
                disabled: disabledTabs.importarRecibos
            },
            {
                key: 'configurarRecibos',
                label: 'Configuração',
                children: <ConfigurarRecibos handleHabilitarAbasAposConfig={handleHabilitarAbasAposConfig} />,
            },
        ]
    }, [disabledTabs, handleHabilitarAbasAposConfig])

    const findDataConfiguracaoRecibo = useCallback(async () => {
        try {
            let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;

            await RecibosConfigurarService.getRecibosConfig(LSEntidade.entity.id, refController.current.signal);

            setDisabledTabs({
                cadastrarRecibos: false,
                importarRecibos: false
            })
            setActiveKeyTabs('cadastrarRecibos')

        } catch (err: any) {

            if (axios.isAxiosError(err) && err.response) {
                const axiosError = err as AxiosError

                if (axiosError?.response?.status === 404) {
                    setDisabledTabs({
                        cadastrarRecibos: true,
                        importarRecibos: true
                    })

                    setActiveKeyTabs('configurarRecibos')
                    notification.warning({
                        message: "Atenção",
                        description: "Defina as configurações para adicionar recibos.",
                    });

                    return
                }

            }

            EmitError(err, true, "Entitys_oasdajsdosp");
        }

    }, []);


    useEffect(() => {

        refController.current = new AbortController();

        if (userCan('manage_receipts')) {

            findDataConfiguracaoRecibo();
        }

    }, []);


    return {
        activeKeyTabs,
        setActiveKeyTabs,
        items,
        userCan,
    }
}
